export default () => {
  const data = {
    event_name: 'tapped_text_field',
    button_name: 'telephone',
    page_section: 'modal_talk_with',
    name_of_the_page_viewed: 'development_details_personal',
  };
  return data;
};
